import { IAction, IManage, IManageComplete, IReducers, IState } from '@src/interfaces';
import { setIn } from 'immutable';
import React from 'react';

const reducer: React.Reducer<IState, IAction> = (s: IState, a: IAction): IState => {

  const setWidgets = (state: IState, action: IAction): IState => {
    return setIn(state, ['widgets'], action.data);
  }

  const setApps = (state: IState, action: IAction): IState => {
    return setIn(state, ['apps'], action.data);
  }

  const setManage = (state: IState, action: IAction): IState => {
    const manage = action.data.map((m: IManage): IManageComplete => {
      return { ...m, category: getManageCategory(m.url), type: 'manage' };
    });
    return setIn(state, ['manage'], manage);
  }

  const setPermissions = (state: IState, action: IAction): IState => {
    return setIn(state, ['permissions'], action.data);
  }

  const setLogin = (state: IState, action: IAction): IState => {
    return setIn(state, ['login'], action.data);
  }

  const setSession = (state: IState, action: IAction): IState => {
    // console.log('setSession', 1, action);
    state = setIn(state, ['session'], action.data);
    // console.log('setSession', 2);
    state = setIn(state, ['is_impersonating'], action.impersonating || false);
    // console.log('setSession', 3);
    if (action.impersonating) {
      state = setIn(state, ['widgets'], undefined);
      state = setIn(state, ['apps'], undefined);
      state = setIn(state, ['manage'], undefined);
    }
    // console.log('setSession', 4, state);
    return state;
  }

  const setArticles = (state: IState, action: IAction): IState => {
    return setIn(state, ['articles'], action.data);
  }

  const setPages = (state: IState, action: IAction): IState => {
    return setIn(state, ['pages'], action.data);
  }

  const setNotice = (state: IState, action: IAction): IState => {
    return setIn(state, ['notice'], action.data);
  }

  const setOrgs = (state: IState, action: IAction): IState => {
    return setIn(state, ['orgs'], action.data);
  }

  const setRequested = (state: IState, action: IAction): IState => {
    return setIn(state, ['requested'], action.data);
  }

  const doneChangePassword = (state: IState, action: IAction): IState => {
    return setIn(state, ['change_password'], action.data);
  }

  const passwordSent = (state: IState, action: IAction): IState => {
    return setIn(state, ['password_sent'], action.data);
  }

  const setUsers = (state: IState, action: IAction): IState => {
    return setIn(state, ['users'], action.data);
  }

  const setSearch = (state: IState, action: IAction): IState => {
    return setIn(state, ['search'], action.data);
  }

  const setImpersonating = (state: IState): IState => {
    return setIn(state, ['is_impersonating'], true);
  }

  const setRealUser = (state: IState): IState => {
    return setIn(state, ['is_impersonating'], false);
  }

  const reducers: IReducers = {
    SET_WIDGETS: setWidgets,
    SET_APPS: setApps,
    SET_MANAGE: setManage,
    SET_PERMISSIONS: setPermissions,
    SET_LOGIN: setLogin,
    SET_SESSION: setSession,
    SET_ARTICLES: setArticles,
    SET_PAGES: setPages,
    SET_NOTICE: setNotice,
    SET_ORGS: setOrgs,
    SET_REQUESTED: setRequested,
    DONE_CHANGE_PASSWORD: doneChangePassword,
    PASSWORD_SENT: passwordSent,
    SET_USERS: setUsers,
    SET_SEARCH: setSearch,
    SET_IMPERSONATING: setImpersonating,
    SET_REAL_USER: setRealUser,
  }

  const getManageCategory = (url: string): string => {
    switch (url.match(/[/][^/]*/)?.[0]) {
      case '/start':
        if (url.indexOf('phpinfo') >= 0) {
          return 'Site Maintenance';
        } else if (url.indexOf('impersonate') >= 0) {
          return 'Tools';
        } else if (url.indexOf('change-password') >= 0) {
          return 'Manage';
        }
        return 'Other';
      case '/permission_manager':
        return 'Manage';
      case '/user_manager':
        return 'Manage';
      case '/alerts':
        return 'Manage';
      case '/org_manager':
        return 'Manage';
      case '/core':
        return 'Manage';
      case '/health':
        return 'Site Maintenance';
      case '/jobs':
        return 'Site Maintenance';
      case '/stash':
        return 'Site Maintenance';
      case '/apc':
        return 'Site Maintenance';
      case '/locations':
        return 'Manage';
    }
    return 'Other';
  }

  return reducers[a.type](s, a);

}

export default reducer;
